async function sendMagicLink(email) {
  try {
    const body = JSON.stringify({
      email: email,
      emailType: "signup",
      urlHistory: [],
    });

    const response = await fetch('/members/api/send-magic-link/', {
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
      method: 'POST',
    });

    const formContainer = document.querySelector('.subscribe');
    formContainer.classList.remove('error');
    formContainer.classList.add('success');
  } catch (error) {
    const formContainer = document.querySelector('.subscribe');
    formContainer.classList.remove('success');
    formContainer.classList.add('error');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.data-members-form');
  if (form) {
    form.addEventListener('submit', async function (e) {
      if (e) {
        e.preventDefault();
        const emailInput = document.querySelector('input[data-members-email]');

        if (!validateEmail(emailInput.value)) {
          const formContainer = document.querySelector('.subscribe');
          formContainer.classList.remove('success');
          formContainer.classList.add('error');
          return;
        }

        await sendMagicLink(emailInput.value);
      }
    });
  }
});

function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
